import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { RichTextBox } from "../../components/richtext/RichTextBox";
import axiosInstance from "../../services/axiosInstance";
import { useTranslationEx } from "../../hooks/useTranslationEx";

function camelCaseToReadable(text: string) {
  return text
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
}

export const getTermPolicy = async ({ type }: { type: string }) => {
  const response = await axiosInstance.get("/termPolicy", {
    params: {
      type,
    },
  });
  return response.data.result;
};

export const TermPolicyPage = () => {
  const { type } = useParams<{ type: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ["termPolicy", type],
    queryFn: async () => getTermPolicy({ type: type ?? "" }),
    enabled: !!type,
  });
  const { t2 } = useTranslationEx();
  if (isLoading) return null;
  return (
    <div className="ui-container">
      <div className="py-[30px]">
        <h1 className="flex items-center text-2xl font-semibold leading-[33px] text-[#232323]">
          {/* {camelCaseToReadable(data?.type ?? "")} */}
          {t2(data?.title)}
        </h1>
      </div>
      <RichTextBox richtext={data?.post?.richtext} />
    </div>
  );
};
